'use client';

import useIsDesktop from "@/hooks/useDesktop";
import LinkButton from "@/app/features/shared/__to_be_integrated/LinkButton";
import { Exhibition } from "@/app/lib/generated/graphql-types";
import { Typography, TypographyProps } from "@mui/material";
import styles from "@/app/features/sites/guided-tours/ui/public/guided-tours-public.module.css";

export function GuidedToursTileLinkButton({ title, exhibition }: { title: string, exhibition?: Exhibition | null }) {

    const sharedLinkButtonProps = {
        link: { url: `/exhibitions/${exhibition?.documentId}` },
        label: title,
        fullWidth: true,
        slots: {
            typography: {
                variant: "h3",
                component: 'h2',
                textTransform: 'none'
            } as TypographyProps
        },
    }

    const typographyProps: TypographyProps= {
        variant: "h2",
        component: "h2",
        color: "primary",
        className: styles.tileTitle
    }

    return useIsDesktop()
        ? (
            exhibition
                ? <LinkButton {...sharedLinkButtonProps} />
                : <Typography {...typographyProps}>{title}</Typography>
        ) : (
            exhibition
                ? (
                    <LinkButton
                        {...sharedLinkButtonProps}
                        slots={{
                            ...sharedLinkButtonProps.slots,
                            typography: {
                                ...sharedLinkButtonProps.slots.typography,
                                variant: "h4",
                            },
                        }}
                    />
                ): (
                    <Typography
                        {...typographyProps}
                        variant="h4"
                    >
                        {title}
                    </Typography>
                )
        )

}